import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Store, Phone, MessageCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { ProductCard } from "../components/ProductCard";
import { Loader, EmptyState } from "../components/Loader";
import { PageHeader } from "../components/PageHeader";
import { Verified } from "../components/Verified";
import { getDisplayName, getDisplayInitial } from "../lib/displayName";
import { FollowButton } from "../components/FollowButton";

export default function SellerPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [seller, setSeller] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        try { setSeller(await api(`/users/${id}/profile`)); } catch {}
        setProducts(await api(`/products?seller_id=${id}`));
      } catch {} finally { setLoading(false); }
    })();
  }, [id]);

  if (loading) return <Loader />;
  const s = seller || {};

  return (
    <div className="animate-fade-in-up max-w-5xl mx-auto">
      <PageHeader title="صفحة المتجر" />
      <div className="bg-white rounded-3xl border border-[#E8EAF2] overflow-hidden">
        <div className="h-28 bg-gradient-to-l from-[#7C5CFF] to-[#A78BFA]" style={s.cover_base64 ? { backgroundImage: `url(${s.cover_base64})`, backgroundSize: "cover" } : {}} />
        <div className="px-6 pb-6 -mt-12">
          {s.picture_base64 || s.picture ? (
            <img src={s.picture_base64 || s.picture} alt="" className="w-24 h-24 rounded-3xl object-cover border-4 border-white" />
          ) : (
            <div className="w-24 h-24 rounded-3xl bg-[#FF3D5A] text-white flex items-center justify-center text-4xl font-black border-4 border-white">{getDisplayInitial(s)}</div>
          )}
          <div className="flex items-center gap-2 mt-3">
            <h1 className="text-xl font-black text-[#161629]">{getDisplayName(s)}</h1>
            {s.verified && <Verified size={18} />}
          </div>
          {s.address && <p className="text-sm text-[#6B7280] mt-1">{s.address}</p>}
          <div className="flex items-center gap-4 mt-3 text-sm">
            <span className="font-black text-[#161629]">{s.follower_count || 0} <span className="text-[#6B7280] font-normal">متابع</span></span>
            {s.avg_rating != null && <span className="font-black text-[#161629]">{Number(s.avg_rating).toFixed(1)} ⭐</span>}
          </div>
          <div className="flex gap-3 mt-4">
            <FollowButton sellerId={id} />
            {s.whatsapp && <a href={`https://wa.me/${s.whatsapp.replace(/[^\d]/g, "")}`} target="_blank" rel="noreferrer" className="flex items-center gap-1.5 px-4 py-2.5 rounded-2xl text-white font-bold text-sm" style={{ backgroundColor: "#25D366" }}><MessageCircle size={16} /> واتساب</a>}
            <button onClick={() => navigate(`/chat/${id}?name=${encodeURIComponent(getDisplayName(s))}`)} className="flex items-center gap-1.5 px-4 py-2.5 rounded-2xl bg-[#161629] text-white font-bold text-sm"><MessageCircle size={16} /> رسالة</button>
          </div>
        </div>
      </div>

      <h2 className="font-black text-[#161629] mt-6 mb-3 flex items-center gap-2"><Store size={18} className="text-[#FF3D5A]" /> المنتجات ({products.length})</h2>
      {products.length === 0 ? (
        <EmptyState icon={Store} title="لا توجد منتجات في هذا المتجر بعد" />
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
          {products.map((p) => <ProductCard key={p.product_id} item={p} promoted={!!p.is_promoted} />)}
        </div>
      )}
    </div>
  );
}
